import { useState } from "react"
import { useDispatch } from "react-redux";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";

import { addList, addPetroNinjaList } from "../reducers/listSlice";
import { colors } from "../helpers/colors";
import { formatUwi } from "../helpers/formatUwi";
import { addWells } from "../reducers/wellSlice";

export const PetroNinjaList = ({ handlePNListClose, projectId, userEmail }) => {
  
  const [listId, setListId] = useState("");

  const dispatch = useDispatch();

  return (
    <Dialog 
      open={true} 
      onClose={handlePNListClose}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle id="form-dialog-title">Add Petro Ninja List</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="normal"
          id="id"
          label="List Id"
          placeholder="List Id"
          type="text"
          fullWidth
          value={listId}
          variant="outlined"
          onChange={e => setListId(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handlePNListClose} color="primary">
          Cancel
        </Button>
        <Button onClick={() => handleAddPNListClick(userEmail, projectId, listId)} color="primary" variant="contained" disabled={listId?.length === 0}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );

  function handleAddPNListClick(userEmail, projectId, listId) {
    try {
      dispatch(addPetroNinjaList({user: userEmail, projectId: projectId, listId: listId})).then(res => {
        const list = res?.payload?.list;
        if (!list) return;
  
        const uwiArray = list?.wellUwis;
        let wells = {};
        for (let uwi of uwiArray) {
          const color = colors[Math.floor(Math.random() * colors.length - 1)];
          wells[uwi] = {
            uwi,
            formattedUwi: formatUwi(uwi),
            color,
            lastModified: new Date().toLocaleString(),
            status: 'idle'
          };
        };
  
        console.log(wells);
  
        dispatch(addList({projectId: (projectId || "default"), list: list}));
        dispatch(addWells({uwis: uwiArray, wells: wells, listId: listId}));
      });
      handlePNListClose();
      
    } catch (error) {
      console.log('Could not fetch Petro Ninja list!');
      handlePNListClose();
      return;
    };
  };
};